const config = {
  blockCheck: true,
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page042_game0/audio/57_legs.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page042_game0/img/audioOn.png', iconOff: 'games/page042_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -48,
        x: 140,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page042_game0/audio/58_hands.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page042_game0/img/audioOn.png', iconOff: 'games/page042_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -48,
        x: 140,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page042_game0/audio/59_head.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page042_game0/img/audioOn.png', iconOff: 'games/page042_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -48,
        x: 140,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: 'games/page042_game0/audio/60_tummy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page042_game0/img/audioOn.png', iconOff: 'games/page042_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -48,
        x: 140,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
  ],
  mainImage: {
    src: 'games/page042_game0/img/bcg.webp',
  },

  multiconnect: false,
  globalItemsConfig: {
    hookPoint: {
      rad: 0,
    },
  },
  dontCheckIncorrectLines: false,
  dontAcceptIncorrectLines: true,
  linesStyle: {
    colors: {
      bad: 'red',
      good: 'green',
      neutral: '#4cb9fa',
    },
    size: 5,
  },
  rules: [
    { connectId: 1, connectedWith: 5 },
    { connectId: 2, connectedWith: 6 },
    { connectId: 3, connectedWith: 7 },
    { connectId: 4, connectedWith: 8 },
  ],
  autoCheck: true,
  numberOfGoodLines: 3,
  sounds: [
    { src: 'games/page042_game0/audio/false.mp3', id: 'endConnect' },
    { src: 'games/page042_game0/audio/click.mp3', id: 'startConnect' },
    { src: 'games/page042_game0/audio/57_legs.mp3', id: 'legs' },
    { src: 'games/page042_game0/audio/58_hands.mp3', id: 'hands' },
    { src: 'games/page042_game0/audio/59_head.mp3', id: 'head' },
    { src: 'games/page042_game0/audio/60_tummy.mp3', id: 'tummy' },
  ],
  groups: [
    {
      name: 'left',
      disableShuffle: false,
      items: [
        {
          connectId: 1,
          audioId: 'head',
          audio: 'a03',
          image: { src: 'games/page042_game0/img/d3.webp' },
          imageStyle: { position: 'absolute', width: '347px', height: '310px' },
          pos: {
            x: 101,
            y: 170,
            width: 347,
            height: 310,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          // hooks: [{ x: 100, y: 1 }],
        },
        {
          audioId: 'hands',
          audio: 'a02',
          connectId: 2,
          image: { src: 'games/page042_game0/img/d1.webp' },
          imageStyle: { position: 'absolute', width: '347px', height: '310px' },
          pos: {
            x: 101,
            y: 646,
            width: 347,
            height: 310,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          // hooks: [{ x: 100, y: 1 }],
        },
        {
          audioId: 'tummy',
          audio: 'a04',
          connectId: 3,
          image: { src: 'games/page042_game0/img/d4.webp' },
          imageStyle: { position: 'absolute', width: '347px', height: '310px' },
          pos: {
            x: 1466,
            y: 646,
            width: 347,
            height: 310,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          // hooks: [{ x: 100, y: 1 }],
        },
        {
          audioId: 'legs',
          audio: 'a01',
          connectId: 4,
          image: { src: 'games/page042_game0/img/d2.webp' },
          imageStyle: { position: 'absolute', width: '347px', height: '310px' },
          pos: {
            x: 1466,
            y: 170,
            width: 347,
            height: 310,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          // hooks: [{ x: 100, y: 1 }],
        },
      ],
    },

    {
      name: 'right',
      disableShuffle: true,
      items: [
        {
          connectId: 5,
          image: { src: 'games/page042_game0/img/cherry_t.png' },
          imageStyle: { position: 'absolute', width: '197px', height: '94px' },
          pos: {
            x: 613,
            y: 290,
            width: 197,
            height: 108,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          // hooks: [{ x: 0, y: 0 }],
        },
        {
          connectId: 5,
          image: { src: 'games/page042_game0/img/cherry_t.png' },
          imageStyle: { position: 'absolute', width: '154px', height: '200px' },
          pos: {
            x: 910,
            y: 100,
            width: 154,
            height: 200,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          // hooks: [{ x: 0, y: 0 }],
        },
        {
          connectId: 5,
          image: { src: 'games/page042_game0/img/head.png' },
          imageStyle: { position: 'absolute', width: '358px', height: '268px' },
          pos: {
            x: 812,
            y: 300,
            width: 358,
            height: 268,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 170, y: 90 }],
        },
        {
          connectId: 6,
          image: { src: 'games/page042_game0/img/cherry_t.png' },
          imageStyle: { position: 'absolute', width: '135px', height: '94px' },
          pos: {
            x: 716,
            y: 570 - 40,
            width: 197,
            height: 108 + 40,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 50, y: 40 }],
        },
        {
          connectId: 6,
          image: { src: 'games/page042_game0/img/cherry_t.png' },
          imageStyle: { position: 'absolute', width: '117px', height: '208px' },
          pos: {
            x: 1176,
            y: 290,
            width: 117,
            height: 208,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 70, y: 55 }],
        },

        {
          connectId: 7,
          image: { src: 'games/page042_game0/img/cherry_t.png' },
          imageStyle: { position: 'absolute', width: '170px', height: '171px' },
          pos: {
            x: 956,
            y: 668,
            width: 197,
            height: 108,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 130, y: 85 }],
        },
        {
          connectId: 8,
          image: { src: 'games/page042_game0/img/cherry_t.png' },
          imageStyle: { position: 'absolute', width: '125px', height: '216px' },
          pos: {
            x: 950 - 70,
            y: 800,
            width: 197 + 70,
            height: 208,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 95 + 70, y: 85 }],
        },
      ],
    },
  ],
};
export default config;
